<template>
  <b-container class="footer-container gov-footer">
    <b-row>

      <b-col class="text-left gov-footer__headline" col md="6">
        <span>{{ $t("portal.informations") }}</span>
      </b-col>

      <b-col class="text-right" col md="6">
        <b-btn class="footer-button" @click="scrollToTop()">
          <span class="sr-only">{{ $t("portal.back-to-top") }}</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="text-left" col md="6">
        <router-link :to="'/' + $customerUuid + '/podminky'">
          {{ $t("portal.conditions") }}
        </router-link>
      </b-col>
      <b-col class="text-left" col md="6">
        <a :href="organizace.odkazObecUrl" v-if="organizace.odkazObecNazev && organizace.odkazObecUrl" @click.prevent="odkazObceVNovemOkne()" variant="secondary">
          {{ organizace.odkazObecNazev.toUpperCase() }}
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left" col md="6">
        <router-link :to="'/' + $customerUuid + '/ochrana'">
          {{ $t("portal.protection") }}
        </router-link>
      </b-col>
      <b-col class="text-right" col md="6" />
    </b-row>
    <b-row>
      <b-col class="text-left" col md="6">
        <router-link :to="'/' + $customerUuid + '/prohlaseni-o-pristupnosti'">
          {{ $t("portal.accessibility-statement") }}
        </router-link>
      </b-col>
      <b-col class="text-right" col md="6" />
    </b-row>

    <b-row>
      <div class="empty-row" />
    </b-row>
    <b-row>
      <hr />
    </b-row>

    <b-row>

      <b-col class="text-left" col md="8">
        <span class="gov-footnote">&copy; {{ new Date().getFullYear() }} ALIS spol. s r.o.</span>
      </b-col>
      <b-col class="text-right" col md="4">
        <span id="label-version" class="gov-footnote">{{ $t('portal.version') + ' ' + version }}</span>
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      isAuthenticationGranted: null,
    };
  },
  computed: mapState([
    "organizace",
  ]),
  mounted() {
    this.$backend.getAuthenticationStatus(response => {
      this.isAuthenticationGranted = this.$utils.isAuthenticationGranted(response);
    });
  },
  methods: {
    scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    odkazObceVNovemOkne() {
      window.open(this.organizace.odkazObecUrl, "_blank");
    },
  },
};
</script>
